import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BaseComponent } from '~console/app/~shared/abstract-components/base.component';
import { ROUTES } from '~console/app/~shared/constants/routes.constants';

@Component({
  selector: 'ntd-verification-form',
  standalone: false,
  templateUrl: './ntd-verification-form.component.html',
  styleUrl: './ntd-verification-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NtdVerificationFormComponent extends BaseComponent {
  routes = ROUTES;
  organizationNtd = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);

  readonly isLoggingInWithNtd$ = this._authFacade.isLoggingInWithNtd$;

  onSubmit(): void {
    const payload = this.organizationNtd.value as string;

    if (this.organizationNtd.invalid) {
      this.organizationNtd.markAllAsTouched();
      return;
    }
    this._authFacade.loginWithOrganizationNtd(payload);
  }
}
